import { formatShortcutKeys } from './formatShortcutKeys'

export const formatShortcutTitle = (baseTitle: string, resolvedKeys: string): string => {
  const formatted = formatShortcutKeys(resolvedKeys)
  if (!formatted) return baseTitle
  return `${baseTitle} (${formatted})`
}
